import type { PlayerEventBus } from '../events/eventBus';
import { effectiveDurationForProgress } from './media';

/**
 * Bridges HTMLMediaElement progress into the event bus (`time`, `pause`, `remove`).
 * App code uses the same bus via `player.on('time', ...)`, etc.
 */
export function attachProgressController(
  video: HTMLVideoElement,
  options: { treatAsLive: boolean; bus: PlayerEventBus },
): { disconnect: () => void } {
  const dispatchTime = () => {
    const payload = {
      position: video.currentTime,
      duration: effectiveDurationForProgress(video, options.treatAsLive),
    };
    options.bus.emit('time', payload);
  };

  const onVideoPause = () => {
    options.bus.emit('pause');
  };

  video.addEventListener('timeupdate', dispatchTime);
  video.addEventListener('pause', onVideoPause);

  const disconnect = () => {
    video.removeEventListener('timeupdate', dispatchTime);
    video.removeEventListener('pause', onVideoPause);
    options.bus.emit('remove');
  };

  return { disconnect };
}
